import translating from './translate.json';
import { validateForm } from '../../utils';

const userForm = translating.userForm;

const fields = (rolesList, isCreate) => {
  const filterRolesList = rolesList.filter(
    (role) => role.name !== 'Therapist' && role.name !== 'Medical Staff'
  );
  let fieldsList = [
    {
      name: 'first_name',
      label: userForm.firstname,
      pattern: validateForm('first_name', userForm.firstname),
      required: true
    },
    {
      name: 'last_name',
      label: userForm.lastname,
      required: true,
      pattern: validateForm('last_name', userForm.lastname)
    },
    {
      name: 'email',
      label: userForm.email,
      required: true,
      pattern: validateForm('email', userForm.email)
    },
    {
      name: 'torForYouUuid',
      label: translating.torforuuuid
    },
    {
      name: 'mobile',
      label: userForm.phone,
      required: true,
      pattern: validateForm('mobile', userForm.phone)
    },
    {
      name: 'job_description',
      required: true,
      label: userForm.description
    }
  ];
  if (isCreate)
    fieldsList.push({
      name: 'password',
      required: true,
      label: userForm.password,
      type: 'password',
      pattern: validateForm('password', userForm.password)
    });
  else
    fieldsList.push({
      name: 'isActive',
      required: true,
      label: userForm.status,
      type: 'switch'
    });
  fieldsList.push({
    name: 'role',
    subField: 'name',
    required: true,
    label: userForm.permission,
    type: 'radio',
    options: filterRolesList,
    default: 'Therapist',
    flex: true,
    breakLine: true
  });
  return fieldsList;
};

export default fields;
